var LangType = {
    RAY_DEFAULT: 0,
    ZH_CN: 2
}
export default LangType;
  